import { canOpen } from './accessState';
import type { ProductSections } from './productSections';

export type ScenarioKey = 'no-entitlement' | 'admin-only' | 'single-app' | 'multi-app';

// Which landing state a user is actually in, derived from their resolved product
// sections — the data decides, replacing the manual scenario picker. Pure: no React, no I/O.
// Admin-only tiles (e.g. the Org Control Panel) do not count as launchable products: an org
// whose only "active" entry is an admin tile has nothing to launch.
// Single-app applies only to members: they skip the hub straight to their one product.
// A member whose one product enforces roles they do not hold stays on the grid to ask for access.
// Org-admins always get the grid — trials and admin surfaces live on the hub.
export function resolveScenario(
  sections: ProductSections,
  isOrgAdmin: boolean,
  roles: readonly string[] | null | undefined,
): ScenarioKey {
  const launchable = sections.active.filter(([product]) => !product.requiresOrgAdmin);

  if (launchable.length === 0)
    return sections.active.length > 0 ? 'admin-only' : 'no-entitlement';
  if (launchable.length === 1 && !isOrgAdmin && canOpen(launchable[0][0].key, launchable[0][1], roles))
    return 'single-app';
  return 'multi-app';
}
